import { render, staticRenderFns } from "./rcc-table.vue?vue&type=template&id=1eb860e5&"
import script from "./rcc-table.vue?vue&type=script&lang=js&"
export * from "./rcc-table.vue?vue&type=script&lang=js&"
import style0 from "./rcc-table.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports